import { prepareRequest } from './request'
import { logger } from '../utils'

export const getAvailableMarkets = ({
  eventId,
  paging = {
    currentPage: 0,
    itemsPerPage: 100
  },
  language = 'ENG',
  signal = null
}) => {
  logger.debug('BespokeMarketService.getAvailableMarkets', { eventId, language })

  const request = prepareRequest({
    method: 'POST',
    url: 'bonus-service/bespoke-market:search',
    signal
  })

  return request({ eventId, language, paging })
}
